export default "__VITE_ASSET__7KyuRCwm__"